import { Badge } from "@/components/Badge";
import i18n from "@/i18n";
import { DownloadButton } from "@/components/DownloadButton";
import { ExportStatus } from "@/lib/utils/exportStatus";
import { statusToBadgeColor } from "@/lib/utils/statusTobadgeColor";
import { parseDateWithHours } from "@/lib/utils";
import { ColumnDef } from "@tanstack/react-table";
import { Link } from "@heroui/react";
import { Clients } from "@/lib/clients";
import { ClientTables } from "@/lib/clientTables";
import { createEnum } from "@/lib/utils/createEnum";

export type C5DataUpload = {
  id: string;
  generated_at: string;
  client: string;
  report_date: string;
  user_name: string;
  file_name: string;
  status: string;
  provider_config_name?: string;
  created_at?: string;
  updated_at?: string;
};
export const c5DataUploadFields = createEnum<C5DataUpload>();

export const data_upload_columns: ColumnDef<C5DataUpload>[] = [
  { accessorKey: c5DataUploadFields.id, header: "Id" },
  {
    accessorKey: c5DataUploadFields.file_name,
    header: "Nom du fichier",
    cell: ({ getValue }) => {
      const value = getValue() as string;
      return (
        <span className="whitespace-nowrap overflow-hidden text-ellipsis block">
          {value}
        </span>
      );
    },
  },
  { accessorKey: c5DataUploadFields.user_name, header: "Utilisateur" },
  {
    accessorKey: c5DataUploadFields.status,
    header: "Statut",
    cell: ({ getValue }) => {
      const value = getValue() as ExportStatus;
      const badgeColor = statusToBadgeColor[value] || "error";
      return <Badge color={badgeColor} />;
    },
  },
  {
    accessorKey: c5DataUploadFields.provider_config_name,
    header: "Configuration",
  },
  {
    accessorKey: c5DataUploadFields.created_at,
    header: "Date de création",
    cell: ({ row }) => {
      const cell_data: string | undefined = row.getValue(
        c5DataUploadFields.created_at,
      );
      if (cell_data) {
        return parseDateWithHours(cell_data);
      }
      return "";
    },
  },
  {
    accessorKey: c5DataUploadFields.updated_at,
    header: "Dernière Modification",
    cell: ({ row }) => {
      const cell_data: string | undefined = row.getValue(
        c5DataUploadFields.updated_at,
      );
      if (cell_data) {
        return parseDateWithHours(cell_data);
      }
      return "";
    },
  },
  {
    accessorKey: "download",
    header: "Télécharger",
    cell: ({ row }) => {
      const id = row.getValue(c5DataUploadFields.id) as string;
      const fileName = row.getValue(c5DataUploadFields.file_name) as string;
      const href = `${
        import.meta.env.VITE_BACKEND_URL
      }/${Clients.C5}/${ClientTables.C5_DATA_UPLOAD}/download/${id}`;

      return (
        <div className="flex flex-row items-center justify-between w-full">
          <DownloadButton
            href={href}
            filename={`${fileName}`}
            size="sm"
            variant="light"
            color="primary"
            isIconOnly
          />
          <div className="flex justify-end">
            <Link
              href={`${window.location.pathname}/${row.getValue(c5DataUploadFields.id)}`}
              className="text-xs"
              underline="hover"
            >
              {i18n.t("actions.details")}
            </Link>
          </div>
        </div>
      );
    },
  },
];
